"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const file_data_service_1 = require("../../commons/file-data.service");
const map_data_service_1 = require("../../commons/map-data.service");
class UploadComponent {
    constructor(fileManager, mapData) {
        this.fileManager = fileManager;
        this.mapData = mapData;
        this._subs = [];
    }
    ngOnInit() {
        this._subs.push(this.mapData.sceneFolder.state.subscribe(s => this.folder = s));
    }
    ngOnDestroy() {
        this._subs.forEach(s => s.unsubscribe());
    }
    uploadFiles(ds) {
        // TODO fix type, its photos with a s
        this.mapData.scene.value.addFromFiles(ds).subscribe(r => {
            if (!r['photos'].length && !r['transforms'].length)
                alert('none of these files have transforms');
        });
        this.mode = null;
    }
    uploadFolder(f) {
        this.mapData.scene.value.addImagesFromFolder(f).subscribe();
        this.mode = null;
    }
    upload(e) {
        this.fileManager.uploadFiles(Array.from(e.srcElement.files), this.folder);
    }
}
exports.UploadComponent = UploadComponent;
